<template>
  <b-container>
    <!--      breadcrumb-->
    <b-row>
      <b-breadcrumb>
        <b-breadcrumb-item @click="$router.go(-1)">Home</b-breadcrumb-item>
        <b-breadcrumb-item active>{{ customer.fName }} {{ customer.lName }}</b-breadcrumb-item>
      </b-breadcrumb>
    </b-row>
    <!--      button panel -->
    <b-row>
      <b-col>
        <h2>{{ customer.fName }} {{ customer.lName }}</h2>
      </b-col>
    </b-row>
    <b-table
      @row-clicked="gotoRewardsDetails"
      hover
      striped
      class="m-2"
      :fields="fields"
      :items="options">
      <template #cell(customerData)="data">
        <b-avatar :src="data.value.profilePicture">
        </b-avatar>
        <span class="ml-2">{{ data.value.fName }}</span>
        <b-badge :variant="data.value.variant">{{ data.value.value }}</b-badge>
      </template>
      <template #cell(status)="data">
        <b-badge :variant="data.value.variant">{{ data.value.value }}</b-badge>
      </template>
      <template #cell(image)="data">
      <b-button @click="openImage(data.value)">

        <i class="fas fa-eye"></i></b-button>
      </template>


      <template #cell(id)="data">
        <b-button-group v-if="data.item.status == 'UNDER REVIEW'">
          <b-button
            size="sm"
            variant="danger"
            pill
            @click="takeAction(data.value, false)">Reject
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            pill
            @click="takeAction(data.value, true)">Accept
          </b-button>
        </b-button-group>
        <div v-else>
          <p class="text-primary">Completed</p>
        </div>
      </template>
    </b-table>
    <b-modal class="bg-transparent" id="modal-1" centered hide-header hide-footer size="xl" scrollable>
    <div style="">
      <b-img
        v-bind="imgProp"
        :src="previewImage"
        alt="">
      </b-img>
    </div>
    </b-modal>
  </b-container>
</template>
<script>
import { HTTP, HTTP2 } from '@/axios/http-common'

export default {
  name: "OtPointsUser",
  data() {
    return {
      imgProp:{
        center: true,
        height:600,
        width:'auto'
      },
      previewImage:'',
      username: 'User Name',
      custid  : '',
      fields  : [
        {
          key  : 'customerData',
          label: 'Customer'
        },
        {
          key  : 'registrationNumber',
          label: 'Vehicle No'
        },
        'amount',
        {
          key  : 'createdAt',
          label: 'Claim Date'

        },
        {
          key:'image',
          label:'Image'
        },
        {
          key      : 'status',
          label    : 'Status',
          formatter: value => {
            return value === 'UNDER REVIEW' ? {
              value,
              variant: 'warning'
            } : value === 'REJECTED' ? {
              value,
              variant: 'danger'
            } : {
              value,
              variant: 'success'
            }
          }
        },
        {
          key  : "id",
          label: "Actions"
        }
      ],
      options : [],
      customer: []
    }
  },

  created() {
    this.custid = this.$route.params.id
    this.fetchAll()
  }
  ,
  methods: {
    takeAction( id, action ) {
      if (confirm( 'Are you sure?' )) {
        HTTP2.post( 'dash/fuel/cashback/accept', {
            id     : id,
            confirm: action
          } )
          .then( () => {
            alert( 'job done' )
            this.fetchAll()
          } )
        console.log( 'you have deleted, ', id, action )
      }
    },
    async fetchAll() {
      let obj = {
        "customer": this.custid
      }
      if (this.selectedStatus !== 'all') {
        obj.status = this.selectedStatus
      }
      const { data } = await HTTP2.post( 'dash/fuel/cashback', obj )
      const customer = await HTTP.get( 'customer/' + this.custid )
      this.options = data
      console.log( data )
      this.customer = customer.data
    },
    gotoRewardsDetails() {

    },
    openImage(data){
      this.previewImage = data
      this.$bvModal.show('modal-1')
    }


  }
}
</script>
<style scoped>
</style>
